// Testimonial slider
function testimonialSlider($) {
    const testimonials = $('.testimonials[data-multiple-slides="1"]');
    
    for (var i = 0; i < testimonials.length; i++) {
        const testimonial = $(testimonials[i]);
        const slider = testimonial.find('.testimonial__slider');
        const nextArrow = testimonial.find('.next-arrow');
        const prevArrow = testimonial.find('.prev-arrow');
        const dotsWrapper = testimonial.find('.testimonial__dots-wrapper');

        if (typeof slickAnimate === "function") {
            slickAnimate(slider);
        }

        // use setTimeout to initialize each slider in its own JS task to avoid long-running JS tasks
        setTimeout(() => {
            slider.slick({
                infinite: true,
                fade: true,
                dots: true,
                arrows: true,
                speed: 500,
                slidesToShow: 1,
                adaptiveHeight: false,
                autoplay: true,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                appendDots: dotsWrapper,
                autoplaySpeed: 3750,
            });
        }, 0);
    }
}

// Inits
if (typeof jQuery !== 'undefined') jQuery(function($) {
    testimonialSlider($);
});
